import { api } from "./api";

export const focusListFromFocus = (fid) =>
    api.post(`/focus-lists/from-focus/${fid}`, {}, { timeout: 150000 }).then((r) => r.data);
export const focusListCreate = (focusId, fplIds) =>
    api.post(`/focus-lists/create`, { focus_id: focusId, fpl_ids: fplIds }, { timeout: 150000 }).then((r) => r.data);
export const focusListsMine = () =>
    api.get(`/focus-lists/mine`).then((r) => r.data);
export const focusListsAdmin = () =>
    api.get(`/focus-lists/admin`).then((r) => r.data);
export const focusListAdminGet = (id) =>
    api.get(`/focus-lists/admin/${id}`).then((r) => r.data);
export const focusListUpdate = (id, payload) =>
    api.put(`/focus-lists/${id}`, payload).then((r) => r.data);
export const focusListDelete = (id) =>
    api.delete(`/focus-lists/${id}`).then((r) => r.data);
export const focusListsPublic = () =>
    api.get(`/focus-lists`).then((r) => r.data);
export const focusListPublicGet = (slug) =>
    api.get(`/focus-lists/${slug}`).then((r) => r.data);

export const focusVote = (slug, fplId, vote) =>
    api.post(`/focus-lists/${slug}/vote`, { fpl_id: fplId, vote }).then((r) => r.data);
export const focusVotes = (slug) =>
    api.get(`/focus-lists/${slug}/votes`).then((r) => r.data);
export const focusListTranslate = (slug) =>
    api.post(`/focus-lists/${slug}/translate`, {}, { timeout: 120000 }).then((r) => r.data);
